import { render, staticRenderFns } from "./BusCommonManageAppModal.vue?vue&type=template&id=5b4f7891&"
import script from "./BusCommonManageAppModal.vue?vue&type=script&lang=js&"
export * from "./BusCommonManageAppModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports